//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex' // 引入mapState
// import { messageHandling } from '~/config/backMessage'
import userHeader from '~/components/login/userHeader.vue' // 头部
import userTabs from '~/components/login/userTabs.vue' // tab
import userCountry from '~/components/login/userCountry.vue' // 国家
import wikiGeet from '~/components/common/wikiGeet.vue' // 极验
import userVerificacode from '~/components/login/userVerificacode.vue' // 验证码
import userVoicevercode from '~/components/login/userVoicevercode.vue' // 语音验证码
import userThreparty from '~/components/login/userThreparty.vue' // 三方登录
import userGraphical from '~/components/login/userGraphical.vue' // 图形验证码
export default {
  name: 'UserReset',
  components: {
    'user-header': userHeader, // 头部
    'user-tabs': userTabs, // tab栏
    'user-country': userCountry, // 国家
    'wiki-geet': wikiGeet, // 极验
    'user-verificacode': userVerificacode, // 验证码
    'user-threparty': userThreparty, // 三方登录
    'user-graphical': userGraphical, // 图形验证码
    'user-voicevercode': userVoicevercode // 语音验证码
  },
  props: {},
  data () {
    return {
      firstLoad: true, // 是否为首次加载该组件
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      title: this.$v('重置'), // title
      tabs: [ // tab栏
        { name: this.$v('手机验证码'), type: 1 },
        { name: this.$v('电子邮件'), type: 2 }
      ],
      mobileNumber: this.$store.state.host.includes('wikifx') ? 2 : 1, // 点击tab栏状态改变 1 为手机验证码 2为电子邮箱/手机号
      verificationCode: 1, // 1为验证码 2为手机验证码
      // 验证码重置
      roTade: false, // 国家点击下拉框状态
      phoneSize: false, // 请输入手机号样式漂浮状态
      clearButton: false, // 清空
      phoneLoading: false, // 加载动画显示
      showDrag: false, // 是否展示极验拖拽框
      // 电子邮箱
      emailNumber: false, // 电子邮箱字样漂浮样式
      // 密码
      passwordState: false, // 密码字样漂浮样式
      confirmpasswordState: false, // 确认密码漂浮样式
      oneseyes: false, // 密码type
      twoseyes: false, // 确认密码type
      // 重置数值绑定
      resetin: {
        cellhoneNumber: '', // 重置手机号绑定
        mailorPhone: '', // 邮箱or手机号账号绑定
        formatError: '', // 手机号验证码登录错误提示
        setPassword: '', // 密码
        requestId: '', // 验证码requestid
        setconfirmPassword: '', // 确认密码
        errPassword: '', // 密码的错误提示
        smsCode: '', // 验证码
        emailphone: null // email为邮箱,phone为手机号
      },
      // 验证码
      voiceState: !this.$store.state.host.includes('wikifx'), // 是否展示语音验证
      countOrnot: true, // 是否展示倒计时
      isVercode: false // 是否校验验证码
    }
  },
  computed: {
    ...mapState(['usergetCountry']) // 选中的国家
    // title () {
    //   if (this.switchingState == 1) {
    //     return this.$v('注册')
    //   } else if (this.switchingState == 2) {
    //     return this.$v('创建密码')
    //   } else if (this.switchingState == 3) {
    //     return this.$v('设置基本信息')
    //   } else if (this.switchingState == 4) {
    //     return this.$v('选择您的角色')
    //   } else if (this.switchingState == 5) {
    //     return this.$v('手机')
    //   } else {
    //     return this.$v('注册')
    //   }
    // }
  },
  watch: {
    roTade (newV) { // 监听国家下拉框
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs.userCountry._scrollInit()
        this.$refs.userCountry.getHeight()
      })
    },
    'resetin.cellhoneNumber': {
      immediate: true,
      handler (val) {
        if (val && this.mobileNumber == 1) {
          this.clearButton = true // 清空按钮为true
        } else if (!val) {
          this.resetin.formatError = ''
          this.clearButton = false // 清空按钮为false
        }
      }
    },
    'resetin.mailorPhone' (val) {
      if (val && this.mobileNumber == 2) {
        this.clearButton = true // 清空按钮为true
      } else if (!val) {
        this.resetin.formatError = ''
        this.clearButton = false // 清空按钮为false
      }
    },
    'resetin.setPassword' (val) {
      if (val && this.resetin.setconfirmPassword !== '') {
        this.clearButton = true // 清空按钮and下一步按钮
      } else if (!val) {
        this.clearButton = false // 清空按钮and下一步按钮
      }
    },
    'resetin.setconfirmPassword' (val) {
      if (val && this.resetin.setPassword !== '') {
        this.clearButton = true // 清空按钮and下一步按钮
      } else if (!val) {
        this.clearButton = false // 清空按钮and下一步按钮
      }
    },
    usergetCountry: {
      handler (newValue, oldValue) {
        this.resetin.formatError = ''
      },
      deep: true
      // immediate: true
    }
  },
  created () {
  },
  mounted () {
    document.addEventListener('click', this.coutryClose)
    // this.$nextTick(() => {
    //   document.querySelector('.wiki-head').style.display = 'none'
    // })
  },
  beforeDestroy () {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    voiceVerification () { // 语音获取验证码
      this.mobileNumber = 6 // 修改为语音验证码弹框
    },
    getPhonecode (data = {}) { // 获取验证码
      if (this.resetin.emailphone == 'phone') {
        // this.mobileNumber = 1 // 切换为手机验证码
        // this.verificationCode = 1 // 修改为验证码获取
        // this.getVercode() // 获取验证码
        this.sendVCode(data) // 获取验证码
      } else if (this.resetin.emailphone == 'email') {
        // this.mobileNumber = 2 // 切换为手机验证码
        // this.verificationCode = 1 // 修改为验证码获取
        this.sendEmail() // 发送邮箱验证码
        this.$refs.userverificacode.getSms() // 获取验证码
      }
    },
    geetError () { // 极验错误
      this.showDrag = false // 极验框状态取消
      this.mobileNumber = 5 // 出现图形验证码
    },
    coutryClose (e) { // 点击非组件区域关闭下拉框
      if (!this.$el.contains(e.target)) this.roTade = false
    },
    voiceTran () { // 语音获取验证码
      // this.mobileNumber = 1 // 修改为手机号弹框
      this.countOrnot = false // 展示 获取验证码
      this.mobileNumber = 4 // 修改为验证码弹框
      this.verificationCode = 2// 修改为语音验证码获取
      // this.getVercode() // 出现极验
      this.$nextTick(() => {
        this.$refs.userverificacode.getweebgeet() // 调用极验
      })
    },
    voiceClose () { // 语音获取取消
      this.countOrnot = false // 取消倒计时
      this.mobileNumber = 4 // 跳转为验证码
    },
    switstat (i) { // tab栏切换
      this.resetin.cellhoneNumber = this.phoneLoading = this.resetin.mailorPhone = this.resetin.setPassword = this.resetin.formatError = '' // 手机号验证码登录绑定清空 // 错误提示绑定清空 // 邮箱账号绑定清空
      this.phoneSize = this.emailNumber = this.showDrag = false // 请输入手机号样式状态false // 电子邮件或手机号样式状态false // 电子邮件或手机号密码样式状态false
      this.mobileNumber = i // 显示状态  1为手机验证码  2为手机号/邮箱登录
      // TODO: tab栏为邮箱时则取消语言获取验证码
      if (i == 2) this.voiceState = false
      this.roTade = false // 国家隐藏
    },
    close () { // 清除按钮
      this.resetin.cellhoneNumber = this.resetin.formatError = '' // 手机输入内容为空/手机错误提示为空/邮箱为空
      this.phoneSize = false // 请输入手机号样式为false
      this.phoneLoading = false // 加载动画为false
    },
    logoIn () { // 下一步|登录
      if (this.mobileNumber == 1 && this.resetin.cellhoneNumber != '') { // 为1则是手机号验证码
        this.phoneLoading = true
        // 1.5秒后loading关闭
        setTimeout(() => {
          this.phoneLoading = false
        }, 800)
        this.resetin.emailphone = 'phone'
        this.getVercode() // 获取验证码
      } else if (this.mobileNumber == 3 && this.resetin.setPassword != '' && this.resetin.setconfirmPassword != '') {
        if (this.resetin.setPassword != this.resetin.setconfirmPassword) return (this.resetin.errPassword = this.$v('两次密码不一致'))
        if (this.resetin.setconfirmPassword.length < 6 || this.resetin.setconfirmPassword.length > 20) return (this.resetin.errPassword = this.$v('密码为6-20位，不能包含汉字或空格'))
        this.resetin.errPassword = ''
        this.resetPassword() // 重置密码
      } else if (this.mobileNumber == 2) { // 邮箱校验
        this.resetin.emailphone = 'email'
        this.numberRis() // 校验邮箱
      }
    },
    async numberRis () { // 校验是否注册
      if (this.mobileNumber == 1) {
        const { cellhoneNumber = '' } = this.resetin // 手机号为空true/false
        if (!cellhoneNumber) return false
        // 校验手机号是否注册
        const { succeed = false, extra = '', result = {} } = await this.$api.login.userCheckphone({ areaCode: this.usergetCountry.code, phoneNumber: cellhoneNumber })
        // console.log('result: ', result)
        if (!succeed) return (this.resetin.formatError = extra) // 数据错误
        if (!result.isregister) return (this.resetin.formatError = this.$v('该手机号不存在'))
        console.log('手机号是否注册result: ', result)
        this.showDrag = true // 极验框展示
      } else if (this.mobileNumber == 2) {
        const { mailorPhone = '' } = this.resetin // 手机号为空true/false
        if (!mailorPhone) return false
        // 校验邮箱是否注册
        const { succeed = false, extra = '', result = {} } = await this.$api.login.userMailregis( // 校验邮箱是否注册
          {
            email: this.resetin.mailorPhone,
            languageCode: this.LanguageCode
          }
        )
        if (!succeed) return this.$message.error(extra) // 数据错误
        if (!result) return (this.resetin.formatError = this.$v('邮箱不存在'))
        console.log('邮箱是否注册', result)
        this.sendEmail() // 发送邮箱验证码
      }
    },
    getVercode () { // 获取验证码
      if (this.usergetCountry.code == '0086') { // 如果为国内则走国内手机号验证
        if (!this.resetin.cellhoneNumber) {
          return (this.resetin.formatError = this.$v('用户手机号有误'))
        }
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (myreg.test(this.resetin.cellhoneNumber)) {
          console.log('验证手机号成功')
          this.resetin.formatError = '' // 验证成功则错误消息清空
          this.numberRis() // 校验手机号
        } else {
          console.log('手机号验证失败')
          this.resetin.formatError = this.$v('手机号格式错误')
        }
      } else { // 否则走国外手机号验证
        if (!this.resetin.cellhoneNumber) {
          return (this.resetin.formatError = this.$v('用户手机号有误'))
        }
        const myreg = /^.{5,20}$/
        if (myreg.test(this.resetin.cellhoneNumber)) {
          console.log('国外手机号验证成功')
          this.resetin.formatError = '' // 验证成功则错误消息清空
          this.numberRis() // 校验手机号
        } else {
          this.resetin.formatError = this.$v('手机号格式错误')
        }
      }
    },
    async getUsertion (code) { // 验证码成功之后登录
      console.log('code: ', code)
      // 校验验证码是否正确
      if (this.resetin.emailphone == 'phone') {
        const { succeed = false, extra = '' } = await this.$api.login.userVerifysms({ AreaCode: this.usergetCountry.code, PhoneNumber: this.resetin.cellhoneNumber, Smscode: code, ApplicationType: 7, ValidateSmsCodeType: 3, LanguageCode: this.LanguageCode })
        // this.$message.error(extra)
        if (!succeed) return this.$message.error(extra) // 数据错误
        this.resetin.smsCode = code // 验证码赋值
        this.mobileNumber = 3 // 切换为密码框
      } else if (this.resetin.emailphone == 'email') {
        const { succeed = false, extra = '', result = {} } = await this.$api.login.userVerifymail({ Email: this.resetin.mailorPhone, Code: code, ApplicationType: 7, CountryCode: this.usergetCountry.countryCode, LanguageCode: this.LanguageCode })
        if (!succeed) return this.$message.error(extra) // 数据错误
        this.resetin.requestId = result.requestId
        this.resetin.smsCode = code // 验证码赋值
        this.mobileNumber = 3 // 切换为密码框
      }
    },
    async resetPassword () { // 验证码成功后重置密码
      console.log('重置密码')
      // 修改密码
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userChangePassword({
        npwd: this.resetin.setconfirmPassword, // 密码
        requestId: this.resetin.requestId,
        languageCode: this.LanguageCode,
        userId: '',
        email: this.resetin.emailphone == 'email' ? this.resetin.mailorPhone : '',
        areaCode: this.usergetCountry.code,
        phone: this.resetin.emailphone == 'phone' ? this.resetin.cellhoneNumber : '' // 手机号
      })
      if (!succeed) return (this.resetin.errPassword = extra) // 数据错误
      // this.$message.success(this.$v('修改成功'))
      this.resetin.cellhoneNumber = this.phoneLoading = this.resetin.mailorPhone = this.resetin.setPassword = this.resetin.formatError = '' // 手机号验证码登录绑定清空 // 错误提示绑定清空 // 邮箱账号绑定清空
      console.log('result: ', result)
      this.$emit('loginSwitch', 1)
      // } else if (this.mobileNumber == 2) {
      //   console.log('进去邮箱验证码')
      // }
    },
    async sendEmail () { // 发送邮箱验证码
      // if (this.mobileNumber == 2) {
      console.log('进去邮箱验证码')
      const { mailorPhone = '' } = this.resetin // 为空true/false
      if (!mailorPhone) return false
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userMailcode( // 发送邮件验证码
        {
          email: this.resetin.mailorPhone,
          languageCode: this.LanguageCode,
          emailType: 0,
          applicationType: 7, // 项目类型
          version: 124 // 版本
        }
      )
      if (!succeed) return this.$message.error(extra) // 数据错误
      this.mobileNumber = 4
      console.log(result)
      // }
    },
    async sendVCode (data = {}) { // 验证码登录极验
      this.showDrag = false // 隐藏拖拽框
      // if (this.mobileNumber == 1) {
      const { cellhoneNumber = '' } = this.resetin // 为空true/false
      if (!cellhoneNumber) return false
      // 发送验证码
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.usergetCountry.code, phone: cellhoneNumber, languageCode: this.LanguageCode, msgType: this.verificationCode == 1 ? 0 : 1, smsBusinessType: 1, applicationType: 7, GeetestValidate: data.geetest_validate, GeetestChallenge: data.geetest_challenge })
      // if (!succeed) return this.$message.error(extra) // 数据错误
      // this.resetin.requestId = result.requestid
      // this.verificationCode = 1 // 修改为验证码获取
      // this.mobileNumber = 4
      // }

      const res = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone: cellhoneNumber,
            languageCode: this.LanguageCode,
            msgType: 0,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge,
            captcha_output: data.captcha_output,
            lot_number: data.lot_number,
            pass_token: data.pass_token,
            gen_time: data.gen_time
          },
          {
            Routes: 'usercenter$sendcodegeettest4'
          }
        )
        .catch(() => {
          console.log('sendcodegeettest4')
        })

      const rest = res?.usercenter?.sendcodegeettest4
      console.log('rest::: ', rest)
      if (rest?.success) {
        this.resetin.requestId = rest?.data?.requestid || ''
        this.verificationCode = 1 // 修改为验证码获取
        this.mobileNumber = 4
      } else {
        this.$message.error(rest?.extra)
      }
    },
    async setVercode (data) { // 图形验证成功后发送验证码
      this.showDrag = false // 隐藏拖拽框
      // if (this.mobileNumber == 1) {
      const { cellhoneNumber = '' } = this.resetin // 手机号为空true/false
      if (!cellhoneNumber) return false
      // 发送验证码
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.usergetCountry.code, phone: cellhoneNumber, languageCode: this.LanguageCode, msgType: 0, smsBusinessType: 1, applicationType: 7, GeetestValidate: '', GeetestChallenge: '', graphCode: data })
      // if (!succeed) return this.$message.error(extra) // 数据错误
      // this.resetin.requestId = result.requestid
      // this.mobileNumber = 4
      // }

      const res = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone: cellhoneNumber,
            languageCode: this.LanguageCode,
            msgType: 0,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge,
            captcha_output: data.captcha_output,
            lot_number: data.lot_number,
            pass_token: data.pass_token,
            gen_time: data.gen_time
          },
          {
            Routes: 'usercenter$sendcodegeettest4'
          }
        )
        .catch(() => {
          console.log('sendcodegeettest4')
        })

      const rest = res?.usercenter?.sendcodegeettest4
      console.log('rest::: ', rest)
      if (rest?.success) {
        this.resetin.requestId = rest?.data?.requestid || ''
        this.mobileNumber = 4
      } else {
        this.$message.error(rest?.extra)
      }
    }
  }
}
